import { createLogger } from "browser-bunyan";
type Logger = ReturnType<typeof createLogger>;

export const url = process.env.REACT_APP_API_BYGGDATA_BASE_URL + "api/price";
export const paUrl = process.env.REACT_APP_PRICELISTASSISTANT_BASE_URL;

export interface IPricelist {
    id: number,
    conversionKey?: number,
    fileName: string
    description: string,
}

export default class Item {

    private fetch: ((input: string, init?: RequestInit) => Promise<Response>);
    private log?: Logger;

    constructor(
        f: ((input: string, init?: RequestInit) => Promise<Response>),
        l?: Logger) {
        this.fetch = f;
        this.log = l;
    }

    public urlBdv = (id: number) => url + "/bdv/" + id;

    public url5001 = (id: number) => url + "/5001/" + id;

    public urlPricelistRedirect = (id: number) => paUrl + "?pricelistId=" + id;

    public getLists = () => this.fetch(url)
        .then(r => r.json() as Promise<IPricelist[]>);

    public putList = (l: IPricelist) => this.fetch(url + "/" + l.id,
        {
            body: JSON.stringify(l),
            headers: { "Content-Type": "application/json" },
            method: "put"
        });

    public import5001 = (f: File) => {
        if (this.log) {
            this.log.debug("uploading file of length " + f.size + " bytes");
        }
        this.fetch(url + "/import/5001",
            {
                body: f,
                method: "post"
            });
    }

    public importBdv = (f: File) => {
        if (this.log) {
            this.log.debug("uploading file of length " + f.size + " bytes");
        }
        this.fetch(url + "/import/bdv",
            {
                body: f,
                method: "post"
            });
    }

    public linkPricelist = (id: string) => {
        if (this.log) {
            this.log.debug("linking pricelist with id " + id + " to logged-in user");
        }
        return this.fetch(url + "/lagpris/link/" + id,
            {
                method: "post"
            });
    }

}


// WEBPACK FOOTER //
// ./src/data/item.ts